import React from 'react';
import { Input as AntInput } from 'antd';

/**
 * Componente de Input
 * @param {string} placeholder - Placeholder do input
 * @param {string} value - Valor do input
 * @param {function} onChange - Função de mudança
 * @param {string} type - Tipo do input (text, password, email, etc)
 * @param {boolean} disabled - Se o input está desabilitado
 * @param {string} size - Tamanho do input (large, middle, small)
 * @param {ReactNode} prefix - Prefixo do input
 * @param {ReactNode} suffix - Sufixo do input
 */
const Input = ({ 
  placeholder = '', 
  value = '', 
  onChange = () => {}, 
  type = 'text',
  disabled = false,
  size = 'middle',
  prefix = null,
  suffix = null,
  ...props 
}) => {
  if (type === 'password') {
    return (
      <AntInput.Password
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        size={size}
        prefix={prefix}
        suffix={suffix}
        {...props}
      />
    );
  }

  if (type === 'textarea') {
    return (
      <AntInput.TextArea
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        size={size}
        {...props}
      />
    );
  }

  return (
    <AntInput
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      type={type}
      disabled={disabled}
      size={size}
      prefix={prefix}
      suffix={suffix}
      {...props}
    />
  );
};

export default Input;



